import { CollectionStatusEnum } from "@kanpla/api-contract";
import { type PropsWithChildren } from "react";
import { Link } from "react-router-dom";

import { cn } from "~/lib/utils";

import { CustomerItem } from "./customer-item";

export const MembersGridLayout = ({
  children,
  className
}: PropsWithChildren<{ className?: string }>) => {
  return (
    <div
      className={cn(
        "grid h-full grid-cols-4 grid-rows-7 xl:grid-rows-8 gap-1",
        className
      )}
    >
      {children}
    </div>
  );
};

type MembersGridLinkProps = {
  to: string;
  member: string;
  collectionStatus?: CollectionStatusEnum;
  className?: string;
  onClick?: () => void;
};

const MembersGridLink = ({
  to,
  member,
  collectionStatus,
  className,
  onClick
}: MembersGridLinkProps) => {
  return (
    <Link to={to} className={cn("flex cursor-pointer", className)}>
      <CustomerItem
        name={member}
        orderStatus={collectionStatus ?? CollectionStatusEnum.NO_ORDERS}
        className="w-full"
        onClick={onClick}
      />
    </Link>
  );
};

MembersGridLayout.Link = MembersGridLink;
